'use strict';

import $ from 'jquery';
import { modalSaveReport } from '../../modules/modalSaveReport';

Dropzone.autoDiscover = false;
import 'dropzone';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    dz_default_message: 'Selecione os arquivos que deseja enviar',
    dz_cancel_upload: 'Cancelar o envio',
    dz_remove_file: 'Remover',
    dz_max_files_exceeded: 'Você já adicionou um arquivo',
    dz_file_too_big: 'Arquivo muito grande',
    dz_invalid_file_type: 'Este arquivo não é uma imagem',
    dz_file_too_big: 'O arquivo é muito grande',
  },
  en: {
    dz_default_message: 'Select the files you want to send',
    dz_cancel_upload: 'Cancel upload',
    dz_remove_file: 'Remove',
    dz_max_files_exceeded: 'You have already added a file',
    dz_file_too_big: 'Very large file',
    dz_invalid_file_type: 'This file is not an image',
    dz_file_too_big: 'File is too big',
  },
  es: {
    dz_default_message: 'Selecciona los archivos que deseas enviar',
    dz_cancel_upload: 'Cancelar el envío',
    dz_remove_file: 'Eliminar',
    dz_max_files_exceeded: 'Ya has añadido un archivo',
    dz_file_too_big: 'Archivo muy grande',
    dz_invalid_file_type: 'Este archivo no es una imagen',
    dz_file_too_big: 'El archivo es demasiado grande',
  },
};

const participants = {
  init() {
    modalSaveReport();

    const token = $('meta[name="csrf-token"]').attr('content');

    Dropzone.options.myDropzone = {
      url: 'upload-lista',
      paramName: 'presence_list',
      maxFilesize: 10,
      maxFiles: 50,
      params: {
        _token: token,
      },
      addRemoveLinks: true,
      dictDefaultMessage: tr[lang].dz_default_message,
      dictCancelUpload: tr[lang].dz_cancel_upload,
      dictRemoveFile: tr[lang].dz_remove_file,
      dictMaxFilesExceeded: tr[lang].dz_max_files_exceeded,
      dictFileTooBig: tr[lang].dz_file_too_big,
      dictInvalidFileType: tr[lang].dz_invalid_file_type,
      dictFileTooBig: tr[lang].dz_file_too_big,
      init: function () {
        this.on('success', function (file, response) {
          $('.added_presence').append(
            '<input type="hidden" data-name="' + file.name + '" name="presence_list[]" value="' + response + '"/>'
          );
        });
        this.on('removedfile', function (file, response) {
          $("input[name='presence_list[]']").each(function () {
            if ($(this).attr('data-name') == file.name) {
              $(this).remove();
            }
          });
        });
      },
    };

    $('#myDropzone').dropzone();

    Dropzone.options.myDropzoneterms = {
      url: 'upload-termos',
      paramName: 'terms',
      maxFilesize: 10,
      maxFiles: 50,
      params: {
        _token: token,
      },
      addRemoveLinks: true,
      dictDefaultMessage: tr[lang].dz_default_message,
      dictCancelUpload: tr[lang].dz_cancel_upload,
      dictRemoveFile: tr[lang].dz_remove_file,
      dictMaxFilesExceeded: tr[lang].dz_max_files_exceeded,
      dictFileTooBig: tr[lang].dz_file_too_big,
      dictInvalidFileType: tr[lang].dz_invalid_file_type,
      dictFileTooBig: tr[lang].dz_file_too_big,
      init: function () {
        this.on('success', function (file, response) {
          $('.added_terms').append(
            '<input type="hidden" data-name="' + file.name + '" name="terms[]" value="' + response + '"/>'
          );
        });
        this.on('removedfile', function (file, response) {
          $("input[name='terms[]']").each(function () {
            if ($(this).attr('data-name') == file.name) {
              $(this).remove();
            }
          });
        });
      },
    };

    $('#myDropzoneterms').dropzone();

    Dropzone.options.myDropzoneimage = {
      url: 'upload-imagem',
      paramName: 'images',
      maxFilesize: 10,
      maxFiles: 50,
      acceptedFiles:
        'image/*,application/pdf,application/doc,application/docx,application/ppt,application/pptx,application/xls,application/xlsx',
      params: {
        _token: token,
      },
      addRemoveLinks: true,
      dictDefaultMessage: tr[lang].dz_default_message,
      dictCancelUpload: tr[lang].dz_cancel_upload,
      dictRemoveFile: tr[lang].dz_remove_file,
      dictMaxFilesExceeded: tr[lang].dz_max_files_exceeded,
      dictFileTooBig: tr[lang].dz_file_too_big,
      dictInvalidFileType: tr[lang].dz_invalid_file_type,
      dictFileTooBig: tr[lang].dz_file_too_big,
      init: function () {
        this.on('success', function (file, response) {
          $('.added_images').append(
            '<input type="hidden" data-name="' + file.name + '" name="images[]" value="' + response + '"/>'
          );
        });
        this.on('removedfile', function (file, response) {
          $("input[name='images[]']").each(function () {
            if ($(this).attr('data-name') == file.name) {
              $(this).remove();
            }
          });
        });
      },
    };

    $('#myDropzoneimage').dropzone();
  },
};

export default participants;
